import Password from "../Pages/Password";
import Registration from "../Pages/Registration";
import DevControls from "./DevControls";
import TransitionWrapper from "./TransitionWrapper";
import SideBar from "../Common/Sidebar";
import SignIn from "../Pages/SignIn";
import CustomerService from "../Pages/CustomerService";
import { ReactNode } from "react";
import { useProxy } from "../Custom Hooks/useProxy";
import SetupMfa from "../Pages/SetupMfa";
import ConfirmPhoneFactor from "../Pages/ConfirmPhoneFactor";
import PhoneFactor from "../Pages/PhoneFactor";
import ResetPassword from "../Pages/ResetPassword";
import EnterEmail from "../Pages/EnterEmail";
import VerifyEmail from "../Pages/VerifyEmail";
import Response from "../Pages/Response";

export default function Selector() {
  let displayed: ReactNode;

  const { name, type } = useProxy();

  switch (name) {
    case "SelfAsserted":
      switch (type) {
        case "signUp":
          displayed = <SignUpChildren />;
          break;
        case "mfaSetup":
          displayed = <SetupMfaChildren />;
          break;
        case "enterEmail":
          displayed = <EnterEmailChildren />;
          break;
        case "verifyEmail":
          displayed = <VerifyEmailChildren />;
          break;
        case "resetPassword":
          displayed = <ResetPasswordChildren />;
          break;
        case "response":
          displayed = <ResponseChildren />;
          break;
        default:
          displayed = <></>;
      }
      break;
    case "Unified":
      displayed = <SignInChildren />;
      break;
    case "Phonefactor":
      if (type === "mfaSetup") {
        displayed = <SetupPhoneFactorChildren />;
      } else if (type === "mfa") {
        displayed = <PhoneFactorChildren />;
      } else {
        displayed = <></>;
      }
      break;
    default:
      displayed = <></>;
  }

  return (
    <>
      <DevControls />
      {displayed}
      <SideBar />
    </>
  );
}

function SignUpChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <Registration />
      <Password />
    </TransitionWrapper>
  );
}

function SignInChildren() {
  return (
    <TransitionWrapper>
      <SignIn />
      <CustomerService />
    </TransitionWrapper>
  );
}

function SetupPhoneFactorChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <ConfirmPhoneFactor />
    </TransitionWrapper>
  );
}

function SetupMfaChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <SetupMfa />
    </TransitionWrapper>
  );
}

function PhoneFactorChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <PhoneFactor />
    </TransitionWrapper>
  );
}

function EnterEmailChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <EnterEmail />
    </TransitionWrapper>
  );
}

function VerifyEmailChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <VerifyEmail />
    </TransitionWrapper>
  );
}

function ResetPasswordChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <ResetPassword />
    </TransitionWrapper>
  );
}

function ResponseChildren() {
  return (
    <TransitionWrapper maxWidth="64vw">
      <Response />
    </TransitionWrapper>
  );
}
